export default {
  accountInfo: '賬戶信息',
  personalInfo: '個人信息',
  bankInfo: '銀行信息',
  trading_account_info: '交易賬戶信息',
  addCard: '添加香港銀行卡',
  bankName: '銀行名稱',
  bankNum: '銀行賬號',
  englishName: '賬戶持有人姓名/英文',
  chineseName: '賬戶持有人姓名/中文',
  currency: '銀行貨幣',
  uploadTitle: '上傳銀行證明(必須包含銀行名稱、銀行賬號及閣下姓名全名)',
  uploadTips: '證明文件可以是：</br>' +
  '1. 印有閣下姓名和銀行賬號的提款卡正面；</br>' +
  '2. 印有發出日期（3個月內）的銀行開戶信件；</br>' +
  '3. 印有發出日期（3個月內）的銀行月結單副本/電子月結單。 </br>',
  uploadNotice: '為了保障您的賬戶安全，如您遞交的證明文件不符合要求，客服會第一時間與您聯繫。 ',
  records: '最新記錄',
  toRecords: '添加記錄',
  error: {
    bankNamePlaceholder: '請選擇銀行名稱',
    bankAccountPlaceholder: '請輸入正確的銀行賬號',
    englishNamePlaceholder: '請輸入賬戶持有人姓名/英文',
    chineseNamePlaceholder: '請輸入賬戶持有人姓名/中文',
    currencyPlaceholder: '請選擇銀行貨幣',
    otherCurrencyPlaceholder: '請上傳銀行證明',
    failed: '添加失敗,請重試',
    '30014': '用戶信息有誤,請退出重新提交',
    '30015': '銀行卡信息缺失,請重新提交',
    '30016': '銀行卡號已被使用',
    '30017': '存在未處理訂單'
  },
  currencyOpt: {
    'USD': '美元',
    'HKD': '港幣',
    'CNY': '人民幣'
  },
  noRecords: '無銀行卡添加記錄',
  name: '姓名',
  phone: '電話',
  email: '電子郵件',
  address: '地址',
  STOCK: '證券', // 補充
  FUTURES: '期貨', // 補充
  FOREX: '外匯', // 補充
  IB: 'EddidPro',
  MF: 'FX Pro',
  PM: '現貨黃金',
  account: '賬戶', // 補充
  balance: '餘額', // 補充
  netCashBalance: '淨現金結餘', // 補充
  preBalance: '上日結存',
  loadingData: '正在加載數據...',
  balanceErr: '--',
  todayBalance: '當日結存',
  stockOptionsCash: '香港股票期權賬戶(現金)',
  securitiesCash: '香港及環球證券賬戶(現金)',
  securitiesMargin: '香港及環球證券賬戶(保證金)',
  securitiesDayTradeMargin: '香港證券即日買賣賬戶(保證金)',
  futuresMargin: '香港及環球期貨賬戶(保證金)',
  futuresDayTradeMargin: '香港期貨即日買賣賬戶(保證金)',
  interactiveBrokerIntegratedMargin: '盈透證券綜合戶口(保證金)',
  OPEN: '啟用',
  STOP: '停用',
  CLOSE: '關閉',
  withdrawalLimit:
    '為符合監管機構要求，客戶如欲使用其他新綁定之銀行賬戶作任何出入金之用，該新綁定的銀行賬戶需要有數額不少於10,000港元或等值貨幣的入金記錄，否則艾德證券期貨屆時有機會未能處理閣下的出入金申請。',
  forbidWithdrawal:
    '此已綁定之銀行賬戶未曾將數額不少於HKD10,000或等值的貨幣成功入金至艾德證券期貨,因此未能透過此銀行賬戶出金。',
  accountDormant: '閣下的交易賬戶{accountNumber}（「賬戶」）過去3年未有進行任何活動（包括交易、存款、提款、轉入股票、轉出股票 、更新賬戶資料、登入手機應用程式等），為保障客戶利益，目前賬戶已被視為「不活躍戶」，賬戶的提款及轉出股票功能將受到限製。'
}
